'use strict';

/**
 * Return an array of objects which have properties and values that matches the passed properties object
 *
 * @param {Array} set - the array of objects
 * @param {Object} properties - the object to match with
 * @returns {Array} Returns - An array of objects that matched the passed in properties object
 */
export default function findByMatchingProperties(set, properties) {
    return set.filter(function (entry) {
        return Object.keys(properties).every(function (key) {
            return entry[key] === properties[key];
        });
    });
}



/** WEBPACK FOOTER **
 ** ./src/js/utils/find-matching-properties.js
 **/